/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import { formatWithTimezone } from 'cio/utils/computed-format-with-timezone';
import { CUSTOMER_TIME_ZONE } from 'cio/utils/time-zones';

interface CampaignsTriggerSetupDatePreviewNextPeopleItemArgs {
  person: Record<string, any>;
  zone: string;
  fallbackZone: string;
}

export default class CampaignsTriggerSetupDatePreviewNextPeopleItem extends Component<CampaignsTriggerSetupDatePreviewNextPeopleItemArgs> {
  @formatWithTimezone('args.person.due_at', 'timezone') dueAt!: string;

  @computed('args.{zone,fallbackZone,person.attributes.timezone}')
  get timezone() {
    if (this.args.zone === CUSTOMER_TIME_ZONE.value) {
      return (this.args.person.attributes.timezone as string) || this.args.fallbackZone;
    }

    return this.args.zone;
  }
}
